module.exports = __webpack_public_path__ + "img/home_pic3.ef1fb56f.png";